import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { trackEvent } from 'analytics/trackFunctions'
import useViewport from 'hooks/useViewport'

import ModalContainer from 'components/ModalContainer'
import CardDiscountButton from 'components/discounts/CardDiscount'
import DiscountInfo from 'components/discounts/DiscountInfo'
import { useDiscountStore } from 'store/discounts'

const DiscountsSection = ({ promos }) => {
  const { selectedDiscount, updateSelectedDiscount } = useDiscountStore(
    (state) => ({
      selectedDiscount: state.selectedDiscount,
      updateSelectedDiscount: state.updateSelectedDiscount
    })
  )
  const [showModal, setShowModal] = useState(false)
  const navigate = useNavigate()
  const { isMobile } = useViewport()

  function handleButtons(promo) {
    trackEvent({
      eventName: `bille_inicio_boton_promociones`
    })
    updateSelectedDiscount(promo)

    if (isMobile) {
      navigate(`/promociones/detalle`)
    } else {
      setShowModal(true)
    }
  }

  if (promos.length === 0) {
    return <></>
  }

  return (
    <>
      <section className='mb-8'>
        <h4 className='text-black font-bold text-xs mb-4'>
          Beneficios para vos
        </h4>
        <div className='flex overflow-x-scroll pb-3 px-1 pt-1 gap-4'>
          {promos.map((promotion) => (
            <CardDiscountButton
              key={promotion.id}
              frequency={promotion.days}
              bgImage={promotion.image_url}
              category={promotion.category}
              discount={promotion.title_short}
              paymentMethods={{
                wayni: promotion.payment_method_wayni,
                gpay: promotion.payment_method_gpay,
                mastercard: promotion.payment_method_mastercard
              }}
              btnAction={() => {
                handleButtons(promotion)
              }}
            />
          ))}
        </div>
      </section>
      <ModalContainer
        title='Detalles del beneficio'
        isShown={showModal}
        setModalFunction={setShowModal}
      >
        <DiscountInfo
          paymentMethods={{
            wayni: selectedDiscount?.payment_method_wayni,
            mastercard: selectedDiscount?.payment_method_mastercard,
            gpay: selectedDiscount?.payment_method_gpay
          }}
          paymentMethodDescription={selectedDiscount?.paymen_method_description}
          category={selectedDiscount?.category}
          bgImage={selectedDiscount?.image_url}
          emoji={selectedDiscount?.icon_image_url}
          description={selectedDiscount?.description}
          duration={selectedDiscount?.validity}
          limit={selectedDiscount?.cashback_limit}
          frequency={selectedDiscount?.days}
          discount={selectedDiscount?.title_long}
          termsUrl={selectedDiscount?.terms_url}
        />
      </ModalContainer>
    </>
  )
}

export default DiscountsSection
